export default __webpack_public_path__ + "static/media/logo.27d66135.png";